import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'
import type { IGuildInfo } from '@/types/interfaces';


const initialState: IGuildInfo = {
  admin_uid: 0,
  gid: '',
  role: 0,
  apply_total: 0,
  country_code: '',
  country_icon: '',
  cover: '',
  id: 0,
  member_number: 0,
  name: '',
  admin_info: {
    avatar_url: '',
    birthday: '',
    charm_lv: 0,
    country_icon: '',
    country_id: 0,
    duid: '',
    duid_lv: 0,
    family_id: 0,
    gender: 0,
    gold: 0,
    guild_id: 0,
    nickname: '',
    noble_lv: 0,
    private_bubble_id: 0,
    uid: 0,
    vip_lv: 0,
    wealth_lv: 0
  },
}

export const slice = createSlice({
  name: 'guildInfo',
  initialState,
  reducers: {
    setGuildInfo: (state, action: PayloadAction<IGuildInfo>) => {
      const payload = action.payload
      setStoreState(state, payload)
      storageUtil.setSessionStorage('guildInfo', JSON.stringify(payload))
    },
  },
})

export const { setGuildInfo: guildInfoActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useCorpInfoStore() {
  const state = useSelector((state: RootState) => state.guildInfo)
  const storageState = storageUtil.getSessionStorage('guildInfo', true) || {}
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState }

  return {
    guildInfo: totalState,
    ...actionPool,
  }
}
